var EventHandler = function () {
    function addEventListener(element, type, handler) {
        if (element.addEventListener) {
            element.addEventListener(type, handler);
        }
        else {
            if (/domcontentloaded/i.test(type)) {
                type = "load";
            }
            element.attachEvent("on" + type, handler);
        }
    }

    return {
        'addEventListener': addEventListener
    };
};

var MessageHandler = function (eventHandler, trustedDomains, targetWindow) {
    var messageCounter = 0,
        events = {};

    function register() {
        console.log("MessageHandler::register");
        eventHandler.addEventListener(window, "message", function (event) {
            if (event.data.type == "webpackOk" || event.data.type == "webpackInvalid") return;
            // HTML-5260  removing safety check for origin due to nature of partner integration
            // if (!isTrustedSource(event.origin)) {
            //     var msg = "MessageHandler.onMessage: origin " + event.origin + " is not trusted to window.postMessage";
            //     if(window.bugsnagClient) {
            //         window.bugsnagClient.notify(new Error(msg));
            //     }
            //     console.warn(msg);
            //     return;
            // }

            try {
                var payload = getDataFrom(event);
                var isJson = payload.constructor === {}.constructor;

                if (!isJson) return;

                //  invoke the required function
                var returnedPromise = execute(payload);
                if (!payload.callback) return;
                // send a message back with the returned Value in order for the original caller to trigger the callback
                Promise.resolve(returnedPromise)
                    .then(function (returnValue) {
                        var response = {
                            name: payload.callback,
                            type: 'gameClient',
                            arguments: returnValue
                        };
                        event.source.postMessage(response, event.origin);
                    })
                    .catch(function (reason) {
                        console.error("something went wrong while sending back the callback", reason);
                    });
            }
            catch (e) {
                console.warn("MessageHandler:: on message caught error: ", e);
            }
        });
    }


    function isTrustedSource(origin) {
        return trustedDomains.includes(origin);
    }

    function getDataFrom(event) {
        var data = event.data;
        if (data.constructor === "test".constructor) {
            try {
                data = JSON.parse(data);
            } catch (e) {
            }
        }

        return data;
    }

    function addEvent(name, callback) {
        events[name] = callback;
    }

    function execute(payload) {
        var method = window[payload.name] || events[payload.name];
        if (!method) {
            console.error("PageIntegration method not found: " + payload.name);
            return;
        }
        if (!payload.arguments && payload.arguments !== false) {
            return method();
        }
        if (Array.isArray(payload.arguments) && method.length === payload.arguments.length) {
            return method.apply(null, payload.arguments);
        }
        return method(payload.arguments);
    }

    /**
     * Wraps original function name and parameters into an object that is sent via postMessage to the iframe
     * it also register a callback that will be executed as soon as we receive a postMessage back from the iframe with the result (to keep old callback beahviour in place)
     * @param name
     * @param arguments
     * @param callback
     */
    function sendMessage(name) {
        var params = Array.prototype.slice.call(arguments, sendMessage.length);
        //  we assume in the old implementation callbacks were always passed as last param.
        // we grab it and remove it from param list (we dont want /  cant transfer it to the target - we just want to execute it once the target replies with another message)
        const callback = params[params.length - 1] instanceof Function
            ? params.pop()
            : null;

        var data = {
            'name': name,
            'type': 'gameClient',
            'arguments': params
        };

        //  removed check about targetUrl and trusted domains because partner sites may constantly be added or removed and list cant be quickly updated
        // in case of partner sites which  load integration page that loads our game, the detected target url is not simply the integration page, and we cannot really control that
        // we should probably add some sort of timeout check, because if for some reason the postMessage fails or goes silent / does not reply, and the game awaits for the callback the game could be stuck with no info: very hard to debug
        if (callback) {
            var callbackName = "callbackOf_" + name + "_" + (++messageCounter);
            data['callback'] = callbackName;
            registerCallback(callback, callbackName);
        }
        targetWindow.postMessage(data, "*");
    }


    function registerCallback(callbackFunction, callbackName) {
        window[callbackName] = function (response) {
            console.log("executing callback " + callbackName + " with response " + response);
            callbackFunction(response);
            try {
                delete window[callbackName];
            } catch (e) {
            }
            window[callbackName] = null;
        };
    }

    return {
        'register': register,
        'addEvent': addEvent,
        'sendMessage': sendMessage
    };
};
